import axios from 'axios'
import 'url-search-params-polyfill'
import moment from 'moment'
import _ from 'lodash'

import apiConfiguration from '../utilities/api/apiConfiguration'
import getCookie from '../utilities/session/getCookie'

export const FETCH_LOYALTY_RATES_BEGIN   = 'FETCH_LOYALTY_RATES_BEGIN'
export const FETCH_LOYALTY_RATES_SUCCESS = 'FETCH_LOYALTY_RATES_SUCCESS'
export const FETCH_LOYALTY_RATES_FAILURE = 'FETCH_LOYALTY_RATES_FAILURE'

export const fetchLoyaltyRatesBegin = () => ({
	type: FETCH_LOYALTY_RATES_BEGIN,
})

export const fetchLoyaltyRatesSuccess = loyaltyRates => ({
	type: FETCH_LOYALTY_RATES_SUCCESS,
	payload: loyaltyRates
})

export const fetchLoyaltyRatesError = error => ({
	type: FETCH_LOYALTY_RATES_FAILURE,
	payload: { error }
})

// Handle Availability Fetch & Functionality
export default function fetchLoyaltyRates(ratePlanCode) {
	return (dispatch, getState) => {
		const urlData = getState().availabilityData.urlData
		let flowGuestData = null
		let sessionId = null

		if (
			getCookie('flowSessionId') &&
			getCookie('flowSessionId') !== ''
		) {
			sessionId = getCookie('flowSessionId')
		}

		if (localStorage.flowGuestData) {
			flowGuestData = JSON.parse(localStorage.flowGuestData)
		}

		// Client ID key used by IPS to pull correct brand data
		let currentClientId = null

		if (
			process.env.REACT_APP_FLOW_CLIENT_ID &&
			process.env.REACT_APP_FLOW_CLIENT_ID !== 'null'
		) {
			currentClientId = process.env.REACT_APP_FLOW_CLIENT_ID
		}

		let adultsVal = 1
		let childrenVal = 0
		let currentLanguage = _.get(urlData, 'primaryLangId', 'en')
		let currentCurrency = _.get(urlData, 'currency', 'USD')
		let startDateVal = moment(new Date()).format('YYYY-MM-DD')
		let endDateVal = moment(new Date()).add(1, 'days').format('YYYY-MM-DD')
		let hotelProvider = _.get(urlData, 'hotelProvider', 0)

		if (urlData.currency) {
			currentCurrency = urlData.currency
		}

		if (
			urlData.startDate &&
			urlData.startDate.includes('TODAY')
		) {
			startDateVal = moment().format('YYYY-MM-DD')
		} else if (urlData.startDate) {
			startDateVal = moment(urlData.startDate).format('YYYY-MM-DD')
		}

		if (
			urlData.endDate &&
			urlData.endDate.includes('TODAY')
		) {
			endDateVal = moment().add(urlData.endDate.replace('TODAY', ''), 'days').format('YYYY-MM-DD')
		} else if (urlData.endDate) {
			endDateVal = moment(urlData.endDate).format('YYYY-MM-DD')
		}

		// Set by session OR query with fallback
		if (!_.isEmpty(flowGuestData) && flowGuestData[0].adults) {
			adultsVal = Number(flowGuestData[0].adults)
		} else if (urlData.adults) {
			adultsVal = Number(urlData.adults)
		}

		// Set by session OR query with fallback
		if (!_.isEmpty(flowGuestData) && flowGuestData[0].children) {
			childrenVal = Number(flowGuestData[0].children)
		} else if (urlData.children) {
			childrenVal = Number(urlData.children)
		}

		if (urlData && urlData.hotelProvider) {
			hotelProvider = urlData.hotelProvider
		}

		// URL Params
		let urlParams = {
			resId: urlData.resId,
			startDate: startDateVal,
			endDate: endDateVal,
			adults: adultsVal,
			children: childrenVal,
			childAges: urlData.childAges,
			hotelCode: urlData.hotelCode,
			areaId: urlData.areaId,
			lat: urlData.lat,
			long: urlData.long,
			distance: urlData.distance,
			distanceMeasure: urlData.distanceMeasure,
			chainCode: urlData.chainCode,
			ratePlanCode: ratePlanCode,
			pricingMethod: urlData.pricingMethod,
			primaryLangId: currentLanguage,
			currency: currentCurrency,
			exactMatchOnly: true,
			bestOnly: urlData.bestOnly,
			summaryOnly: urlData.summaryOnly,
			hotelStayOnly: urlData.hotelStayOnly,
			availReqType: urlData.availReqType,
			hotelProvider: hotelProvider,
			clientId: currentClientId,
			sessionId: sessionId,
		}

		// Fetch Query string method
		const fetchQuery = new URLSearchParams()

		// Loop urlParams for undefined values & remove
		for (let key in urlParams) {
			if (typeof urlParams[key] === "undefined") continue
			fetchQuery.append(key, urlParams[key])
		}

		// Base API path
		let apiBase = process.env.REACT_APP_FLOW_ENDPOINT_URL + '/api/hotel/avail-rooms?'

		// Combine API URL & formatted urlParams
		const fetchResult = apiBase + fetchQuery.toString()

		dispatch(fetchLoyaltyRatesBegin())
		return axios.get(fetchResult, apiConfiguration())
			.then((response) => {
				let keyedLoyaltyRates = {}

				const loyaltyRates = _.get(response, 'data["hydra:member"][0].roomStays[0]', {})

				if (!_.isEmpty(loyaltyRates)) {
					keyedLoyaltyRates[ratePlanCode] = loyaltyRates

					dispatch(fetchLoyaltyRatesSuccess(keyedLoyaltyRates))
				}
			})
			.catch(error => {
				dispatch(fetchLoyaltyRatesError(error))
			})
	}
}


// WEBPACK FOOTER //
// ./src/actions/fetchLoyaltyRates.js